export default __webpack_public_path__ + "static/media/threeChildren.9167565b.png";